export default __webpack_public_path__ + "static/media/ic-download.241f2417.svg";